document.addEventListener("DOMContentLoaded", function() {
  function adjustImageForMobile() {
    var images = document.querySelectorAll('.slideshow__media');
    if (window.innerWidth <= 749) {
      images.forEach(function(image) {
        image.style.objectFit = 'cover'; // Ensure the image covers the container
        image.style.objectPosition = 'right'; // Focus on the right side of the image
        image.style.width = '100%';
        image.style.height = 'auto';
      });
    } else {
      images.forEach(function(image) {
        image.style.objectFit = '';
        image.style.objectPosition = '';
        image.style.width = '';
        image.style.height = '';
      });
    }
  }

  // Adjust image on initial load
  adjustImageForMobile();

  // Adjust image on window resize
  window.addEventListener('resize', adjustImageForMobile);
});